import $api from "@/frontend/shared/api/axios";
import { EInvestorAccess } from "./types/types";

export async function postAccessControlsRequest({ companyId, access }: { companyId: number; access: EInvestorAccess }) {
  return $api.post(`/access-controls/request`, { companyId, access });
}
